/* raw layout hash: _default-web-layout:baf0b69bb3d9ffafd38845a94417b511e2f764402bee9d1af789a37ee190b041 */
import React from "react";
import AppShell from "./AppShell.jsx";

// Layout "_default-web-layout" (RawHTMLDesign/layouts/_default-web-layout.html)
export default function DefaultWebLayout({ children }) {
  return <AppShell menuKey="full">{children}</AppShell>;
}
